"use client";

import { useEffect } from "react";

import { usePathname, useSearchParams } from "next/navigation";

import { analytics } from "../index";

export function PageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const url = `${pathname}?${searchParams.toString()}`;
    analytics.pageView(url);
  }, [pathname, searchParams]);

  return null;
}
